import "@/App.css";
import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { ReactLenis } from "lenis/react";
import Landing from "@/pages/Landing";
import LegalPage from "@/pages/LegalPage";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function App() {
  return (
    <BrowserRouter>
      <ReactLenis
        root
        options={{ lerp: 0.09, duration: 1.2, smoothWheel: true, wheelMultiplier: 1 }}
      >
        <div className="App grain min-h-screen bg-[#F9FAFC] font-body text-[#0F1117] antialiased selection:bg-[#2D5BFF] selection:text-white">
          <ScrollToTop />
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/terms" element={<LegalPage slug="terms" />} />
            <Route path="/privacy" element={<LegalPage slug="privacy" />} />
            <Route path="/earnings-claims" element={<LegalPage slug="earnings" />} />
          </Routes>
        </div>
      </ReactLenis>
    </BrowserRouter>
  );
}

export default App;
